import React from 'react';
import { NextPage } from 'next';
import { QUOTE_ROUTE } from 'data/routes';
import { Hero, SEO } from 'templates/layout';
import { CarrierCard, CarrierQuoteSection, FeatureSection } from 'templates/carrier';
import { carrierImage, carriersBgImage } from 'images/carrier';
import { BgMainImage, BoxFindIcon, GraphLineUpIcon, HandDollarIcon, PersonAttachedIcon } from 'svgs';
import { CareerForm } from 'templates/forms';
import { Box } from '@material-ui/core';

const CarriersPage: NextPage = () => (
  <>
    <SEO
      title={'Become a carrier'}
      description={
        'Find out how you can seize the opportunity to become a highly professional carrier for a network with dozens of carriers countrywide.'
      }
    />
    <Hero
      title={
        <>
          <span>UNLIMITED</span>
          <br /> OPPORTUNITIES
        </>
      }
      buttonText={'Get a Quote'}
      text={'A trustworthy partner for experienced carriers '}
      image={carriersBgImage}
      link={QUOTE_ROUTE}
    />

    <CarrierQuoteSection
      title="Become a carrier"
      text="Join Patron Trucking to start working with trustworthy shippers across the U.S."
      linkBtn={{ text: 'Join Us', link: 'carrierForm' }}
    />
    <Box style={{ overflow: 'hidden' }}>
      <CarrierCard
        image={carrierImage}
        title={'Fast-piece Delivery - our top priority.'}
        text={
          'Patron Trucking is a trustworthy brokerage company offering unlimited opportunities for  experienced freight carriers. Delivering hauling freight requires a meticulous approach, competent support, and ample industry experience.'
        }
        staticsList={[
          { quantity: '50+', text: 'Employed Carriers' },
          { quantity: '1k+', text: 'Loads Moved' },
          { quantity: '150+', text: 'Satisfied Shipers' },
        ]}
      />
      <FeatureSection
        bgImage={<BgMainImage width="100%" viewBox="0 0 750 1040" />}
        featuresList={[
          {
            svgIcon: <BoxFindIcon width="100%" viewBox="0 0 78 78" />,
            title: 'Get instant access to available loads',
            text:
              'We help you find your loads – quickly and effectively. Our tools allow the truck carriers to have complete access to all the available loads within our network.',
            underText: 'Your time matters to us',
          },
          {
            svgIcon: <GraphLineUpIcon width="100%" viewBox="0 0 78 78" />,
            title: 'Enjoy stability and growth',
            text:
              'Our network covers the entire country, and independent agents work tirelessly to provide new loads every day. Patron Trucking delivers logistics services that fully meet your business needs.',
            underText: 'Your business is our priority',
          },
          {
            svgIcon: <HandDollarIcon width="100%" viewBox="0 0 78 78" />,
            title: 'Cut your expenses',
            text:
              'Patron Trucking provides reliable solutions for every load our company will haul. We guarantee that you will not have to worry about your costs. By collaborating with us, you’ll receive cost-effective and efficient solutions – simple as that.',
            underText: 'Your costs are reduced',
          },
          {
            svgIcon: <PersonAttachedIcon width="100%" viewBox="0 0 78 78" />,
            title: 'Pick up new loads on a regular basis',
            text:
              'You can flip through, track, assign, and negotiate your loads literally on the go. Patron Trucking network of about 500+ independent agents is sharing loads constantly.',
            underText: 'Your needs are taken care of',
          },
        ]}
      />
    </Box>
    <Box id="carrierForm" />
    <CareerForm />
  </>
);

export default CarriersPage;
